import {Asset} from '../Assets.types';
import {CreativeTemplateType} from '../../creativeTemplates/creativeTemplates.types';
import {AssetType, DerivedFilePurpose} from '../Assets.enums';

/**
 * Gets the appropriate file URL for an asset based on template type
 * @param asset - The asset to get file URL for
 * @param templateType - The template type (for video quality selection)
 * @returns File URL string or null if not available
 */
export default function getAssetFileUrl(
  asset: Asset,
  templateType: CreativeTemplateType,
): string | null {
  function getFileUrl(derivedFilePurpose: DerivedFilePurpose): string | null {
    return (
      asset.derivedFiles.find((file) => file.derivedFilePurpose === derivedFilePurpose)?.technicalMetadata
        ?.fileUrl || asset.originalfile.fileUrl || null
    );
  }

  // For images, use compressed image derivative
  if (asset.assetType === AssetType.Image || asset.assetType === AssetType.AnimatedImage) {
    return getFileUrl(DerivedFilePurpose.CompressedImage);
  }

  // For videos, select quality based on template type
  if (asset.assetType === AssetType.Video) {
    // In-Banner Video or Interactive Video -> Mid Quality
    if (
      templateType === CreativeTemplateType.InBannerVideoAds ||
      templateType === CreativeTemplateType.InteractiveVideoAds
    ) {
      return getFileUrl(DerivedFilePurpose.MidQualityVideo);
    }

    // Video Ads -> High Quality
    if (templateType === CreativeTemplateType.VideoAds) {
      return getFileUrl(DerivedFilePurpose.HighQualityVideo);
    }

    return null;
  }

  // For fonts, use original file URL
  if (asset.assetType === AssetType.Font) {
    return asset.originalfile.fileUrl || null;
  }

  return null;
}
